export enum ParametersStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  TREATED = 'TREATED',
  NOT_USABLE = 'NOT_USABLE'
}
